<template>
    <div>
        <div class="load-box" v-show="isLoad" @click="hideLoad">
            <img class="load" src="@/assets/loading.gif" alt="">
        </div>
    </div>
</template>
<script>
export default {
    name: 'loading',
    data () {
        return {
            isLoad: true
        }
    },
    methods: {
      hideLoad(){
        this.isLoad = false
      }
    }
}
</script>
<style>
    .load-box{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 99999;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.5);
    }
    .load-box .load{
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 10000;
        width: .75rem;
        height: .75rem;
        transform: translate(-50%,-50%);
    }
</style>



// WEBPACK FOOTER //
// src/components/loading.vue